/* template */
<template><div :style="[(customStyle)] | transRpxStyle" class="login-container"><div class="login-card-left"><div class="login-title">请重新登录12306</div><div class="login-writting">当前账号异常，为保证出票，请您重新登录</div></div><div class="login-button"><mpx-image src="https://img-hxy021.didistatic.com/static/starimg/img/XIAyP8vZRa1693324609097.png" class="button-icon"/><mpx-view @tap="go12306login" class="button-writting">去登录</mpx-view></div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m99f1ea5e"}'>
  .login-container
    display flex
    justify-content space-between
    padding 16px
    background #fff
    border-radius 16px
    margin-top 8px
    .login-card-left
      display flex
      flex-direction column
      .login-title
        display flex
        font-family PingFangSC-Medium
        font-size 16px
        line-height 16px
        color #000
      .login-writting
        margin-top 6px
        font-family PingFangSC-Regular
        font-size 12px
        line-height 12px
        color #666
    .login-button
      height 34px
      display flex
      justify-content center
      align-items center
      border-radius 8px
      background #EDF4FF
      padding 0 8px 0 9px
      .button-icon
        height 16px
        width 16px
      .button-writting
        font-family PingFangSC-Medium
        font-size 14px
        line-height 14px
        color #1473FF  
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m99f1ea5e"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./login-card.mpx.js?isComponent&outputPath=components%2Flogin-card99f1ea5e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./login-card.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Flogin-card99f1ea5e%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m99f1ea5e"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/login-card99f1ea5e/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
